import React from "react";
import AssignmentFullViewModal from "./DiffViewModal";
import AssignmentDiffViewer from "./DiffViewer";

const AssignmentCompareModal: React.FC<{
  open: boolean;
  onClose: () => void;
  assignments: Array<{ assignment: Record<string, unknown>; date: Date }>;
}> = ({ open, onClose, assignments }) => {
  if (!assignments || assignments.length !== 2) return null;

  // Sort so older is always left, newer is right
  const [older, newer] =
    assignments[0].date <= assignments[1].date
      ? [assignments[0], assignments[1]]
      : [assignments[1], assignments[0]];

  return (
    <AssignmentFullViewModal
      open={open}
      onClose={onClose}
      assignment={null}
      width="75vw"
      height="75vh"
    >
      <div className="flex h-full w-full flex-1 flex-col">
        <div className="flex h-1/2 w-full flex-1 flex-row gap-2">
          <div className="flex h-full w-full min-w-0 flex-1 flex-col overflow-auto rounded bg-gray-50 p-2">
            <div className="mb-1 text-xs font-semibold">
              Older Version
              <br />
              <span className="text-gray-500">
                {older.date.toLocaleString()}
              </span>
            </div>
            <pre className="h-full w-full flex-1 overflow-auto text-xs">
              {JSON.stringify(older.assignment, null, 2)}
            </pre>
          </div>
          <div className="flex h-full w-full min-w-0 flex-1 flex-col overflow-auto rounded bg-gray-50 p-2">
            <div className="mb-1 text-xs font-semibold">
              Newer Version
              <br />
              <span className="text-gray-500">
                {newer.date.toLocaleString()}
              </span>
            </div>
            <pre className="h-full w-full flex-1 overflow-auto text-xs">
              {JSON.stringify(newer.assignment, null, 2)}
            </pre>
          </div>
        </div>
        <div className="mt-2 flex h-1/2 w-full flex-1 flex-col overflow-auto border-t pt-2">
          <div className="mb-1 text-xs font-semibold">Diff</div>
          <div className="flex min-h-0 flex-1 flex-col">
            <AssignmentDiffViewer
              prev={older.assignment}
              curr={newer.assignment}
            />
          </div>
        </div>
      </div>
    </AssignmentFullViewModal>
  );
};

export default AssignmentCompareModal;
